export function VersionToggle({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
